import Vue from "vue"
import Router from "vue-router"
import Index from "./views/index.vue"
import List from "./views/list.vue"
import Detail from "./views/detail.vue"
import About from "./views/about.vue"
import GameNumber from "@/views/guessNumber";
import MemberInfo from "@/views/memberInfo";
import RockGame from "@/views/rockGame";
import YxAI from "@/views/yxAI";
import UnionLotto from "@/views/unionLotto";
import Search  from "@/views/search";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
        path: "*",
        redirect: "/index",
    }, {
        path: "/index",
        component: Index
    }, {
        path: "/list",
        component: List
    }, {
        path: "/detail",
        component: Detail
    }, {
        path: "/about",
        component: About
    }, {
        path: "/guessNumber",
        component: GameNumber
    }, {
        path: "/memberInfo",
        component: MemberInfo
    }, {
        path: "/rockGame",
        component: RockGame
    }, {
        path: "/yxAI",
        component: YxAI
    }, {
        path: "/unionLotto",
        component: UnionLotto
    }, {
        path: "/search",
        component: Search
    }
    ]
})
